import React, { FC } from 'react'
import { useTranslate } from 'react-polyglot'
import { Button, Typography } from '@getgo/chameleon-web-react-wrapper'
import { Grid } from '@material-ui/core'
import { Dialog, DialogActions } from '@ucc/unified-admin-common'

import { OrganizationContext } from 'components/contexts/OrganizationContext'

interface UpgradeNowDialogProps {
  onClose: () => void
  pbx: OrganizationContext | null
  open: boolean
}

const UpgradeNowDialog: FC<UpgradeNowDialogProps> = ({ onClose, pbx, open }) => {
  const t = useTranslate()
  const pbxId = pbx?.jrn?.split(':')[4] || ''

  return (
    <Dialog size="sm" title={t('Upgrade to GoTo Admin')} onClose={onClose} open={open}>
      <Grid container direction="column" spacing={4}>
        <Grid item>
          <Typography>
            {t('GoTo Admin will become the default portal for all admins on your account. You can switch back anytime')}
          </Typography>
        </Grid>

        <DialogActions>
          <Button variant="neutral" data-testid="switch-back-to-old-admin-cancel-btn" onClick={onClose}>
            {t('Cancel')}
          </Button>
          <Button
            data-testid="switch-back-to-old-admin-btn"
            variant="primary"
            onClick={async () => {
              if (pbx) {
                const upgrade = await pbx.handleUpgrade(pbxId)

                if (upgrade) {
                  onClose()
                }
              }
            }}
          >
            {t('Upgrade')}
          </Button>
        </DialogActions>
      </Grid>
    </Dialog>
  )
}

export default UpgradeNowDialog
